export enum OfferingTypeStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
}

export enum OfferingTypeKind {
  PERMANENT = "PERMANENT",
  TEMPORARY = "TEMPORARY",
}

export enum OfferingTypeStatusFilter {
  ALL = "ALL",
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
}

export enum OfferingTypeScope {
  PARISH = "PARISH",
  BRANCH = "BRANCH",
}

export type BranchSummary = {
  id: string
  workspaceId: string
  name: string
  slug: string
  status: string
}

export interface MockProgramOption {
  id: string
  title: string
}

export interface OfferingType {
  id: string
  workspaceId?: string | null
  name: string
  description?: string | null
  scope: OfferingTypeScope
  ownerBranchId?: string | null
  status: OfferingTypeStatus
  kind: OfferingTypeKind
  linkedProgramId?: string | null
  startDate?: string | null
  endDate?: string | null
  ownerBranch?: BranchSummary | null
  source?: string
  createdAt: string
  updatedAt: string
}

export interface CreateOfferingTypeInput {
  name: string
  description?: string
  scope: OfferingTypeScope
  ownerBranchId?: string
  status?: OfferingTypeStatus
}

export interface UpdateOfferingTypeInput {
  name?: string
  description?: string
  scope?: OfferingTypeScope
  ownerBranchId?: string
  status?: OfferingTypeStatus
}

export type OfferingTypesListQuery = {
  workspaceId: string
  scope?: OfferingTypeScope
  status?: OfferingTypeStatus
  ownerBranchId?: string
  q?: string
  page?: number
  limit?: number
}

export type OfferingTypesListResponse = {
  items: OfferingType[]
  total: number
  page: number
  limit: number
}
